import activityService from "../../services";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    activities: [],
    urgencies: [],
    working: false,
    pagination: { current_page: 1 },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    activities(state) {
      return state.activities;
    },
    urgencies(state) {
      return state.urgencies;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setActivities(state, payload) {
      state.activities = payload;
    },
    setUrgentActivities(state, payload) {
      state.urgencies = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    async getActivities({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await activityService.fetchActivities(payload);
        commit("setActivities", res.data.data);
        commit("setUrgentActivities", res.data.data);
        commit("setPagination", res.data.pagination);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editActivity({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await activityService.updateActivity(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل النشاط بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل النشاط",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async addActivity({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await activityService.saveActivity(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت إضافة النشاط بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة النشاط",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteActivity({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await activityService.deleteActivity(id);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم حذف النشاط بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء حذف النشاط",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },
    // async getNgoRelatedServices({ commit }) {
    //   commit("setLoading", true);
    //   try {
    //     const res = await activityService.fetchServices();
    //     commit("setActivities", res.data.activities);
    //     commit("setUrgentActivities", res.data.urgencies);
    //   } catch (err) {
    //
    //   } finally {
    //     commit("setLoading", false);
    //   }
    // },
  },
};
